import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const AddPlaidAccount = gql`
  mutation AddPlaidAccount(
    $idempotencyId: IdempotencyToken!
    $input: AddPlaidAccountInput!
  ) {
    addPlaidAccount(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on AddPlaidAccountSuccess {
        title
        message
      }
      ... on AddPlaidAccountDuplicateItemOnIdentityMismatchedError {
        ...error
      }
      ... on AddPlaidAccountLinkError {
        ...error
      }
      ... on AddPlaidAccountError {
        ...error
      }
    }
  }
  ${error}
`;
